import { StyledButton } from './styled';

const SearchCarRentalButton = ({
  onClick,
  disabled,
  isHomePage,
}: {
  onClick: VoidFunction;
  disabled?: boolean;
  isHomePage?: boolean;
}) => {
  return (
    <StyledButton
      onClick={onClick}
      disabled={disabled}
      type={isHomePage ? 'primary' : 'secondary'}
    >
      {isHomePage ? 'Araç' : 'Yeniden'} Ara
    </StyledButton>
  );
};

export default SearchCarRentalButton;
